export default function Logo({ dark = false, size = 1, lang = 'en' }) {
  const isAr = lang === 'ar';
  const h = 40 * size;
  const w = isAr ? 260 * size : 213 * size;

  return (
    <svg width={w} height={h} viewBox={`0 0 ${isAr ? 415 : 340} 64`} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lg" x1="0%" y1="0%" x2="60%" y2="100%">
          <stop offset="0%" stopColor="#00D4FF" />
          <stop offset="100%" stopColor="#0057FF" />
        </linearGradient>
      </defs>
      {isAr ? (
        /* Arabic: icon on the right side of the text */
        <>
          <text x="0" y="47" fontFamily="'Tajawal','Arial',sans-serif"
            fontSize="34" fontWeight="800" letterSpacing="1"
            fill={dark ? '#0B1437' : '#FFFFFF'}>روت روفر</text>
          <polygon points="360,60 376,4 394,4 378,60" fill="url(#lg)" />
          <polygon points="398,60 414,4 415,4 413,60" fill="url(#lg)" opacity="0.75" />
        </>
      ) : (
        /* English: icon on the left */
        <>
          <polygon points="0,60 16,4 34,4 18,60" fill="url(#lg)" />
          <polygon points="38,60 54,4 68,4 52,60" fill="url(#lg)" opacity="0.75" />
          <text x="84" y="47" fontFamily="'Inter','Segoe UI',Arial,sans-serif"
            fontSize="34" fontWeight="800" letterSpacing="1.5"
            fill={dark ? '#0B1437' : '#FFFFFF'}>ROUTE ROVER</text>
        </>
      )}
    </svg>
  );
}
